import axios from 'axios';

import { ACQUIRE_LOCK_FOR_ENTITY_REQUEST, ACQUIRING_LOCK_FOR_ENTITY_FAILED, ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED, BREAKING_LOCK_FOR_ENTITY_FAILED, BREAKING_LOCK_FOR_ENTITY_SUCCEDDED, BREAK_LOCK_FOR_ENTITY_REQUEST, INVALIDATE_LOCK_STATE, RELEASE_LOCK_FOR_ENTITY_REQUEST, RELEASING_LOCK_FOR_ENTITY_FAILED, RELEASING_LOCK_FOR_ENTITY_SUCCEDDED } from 'constants/actionTypes';
import { createAction } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import LockService from 'services/lock.service';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const LOCK_URL = `${apiUrl}/api/2.0/lock`;

export const acquireLock = createAction(ACQUIRE_LOCK_FOR_ENTITY_REQUEST, (reference) => {
  return {
    reference,
  };
});

const acquiringLockSuccedded = createAction(ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED, (reference, response) => {
  return {
    reference,
    response,
  };
});

const acquiringLockFailed = createAction(ACQUIRING_LOCK_FOR_ENTITY_FAILED, (reference, error) => {
  return {
    reference,
    error,
  };
});

function* acquireLockSaga(action) {
  const { reference } = action.payload;

  const request = {
    reference,
  }

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock(reference),
  }
  
  const acquireLockAPI = () => {
    return axios.post(LOCK_URL, request, {
      headers: headers,
    }).then(response => response.data);
  }

  try {
    const response = yield call(acquireLockAPI);
    if (response) {
      LockService.saveLock(reference, response.token);
      yield put(acquiringLockSuccedded(reference, response));
    }
  } catch (error) {
    yield put(acquiringLockFailed(reference, error));
  }
}

/**
 * Release lock
 * 
*/
export const releaseLock = createAction(RELEASE_LOCK_FOR_ENTITY_REQUEST, (reference) => {
  return {
    reference,
  };
});

const releasingLockSuccedded = createAction(RELEASING_LOCK_FOR_ENTITY_SUCCEDDED, (reference, response) => {
  return {
    reference,
    response,
  };
});

const releasingLockFailed = createAction(RELEASING_LOCK_FOR_ENTITY_FAILED, (reference, error) => {
  return {
    reference,
    error,
  };
});

function* releaseLockSaga(action) {
  const { reference } = action.payload;

  let url = buildUrl(LOCK_URL, {
    path: `/release`
  });

  const request = {
    reference,
  }

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock(reference),
  }
  
  const releaseLockAPI = () => {
    return axios.post(url, request, {
      headers: headers,
    }).then(response => response.data);
  }

  try {
    yield call(releaseLockAPI);
    LockService.removeLock(reference);
    yield put(releasingLockSuccedded(reference));
  } catch (error) {
    yield put(releasingLockFailed(reference, error));
  }
}

/**
 * Release lock
 * 
*/
export const breakLock = createAction(BREAK_LOCK_FOR_ENTITY_REQUEST, (reference) => {
  return {
    reference,
  };
});

const breakingLockSuccedded = createAction(BREAKING_LOCK_FOR_ENTITY_SUCCEDDED, (reference, response) => {
  return {
    reference,
    response,
  };
});

const breakingLockFailed = createAction(BREAKING_LOCK_FOR_ENTITY_FAILED, (reference, error) => {
  return {
    reference,
    error,
  };
});

function* breakLockSaga(action) {
  const { reference } = action.payload;

  let url = buildUrl(LOCK_URL, {
    path: `/break`
  });

  const request = {
    reference,
  }
  
  const breakLockAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(breakLockAPI);
    if (response) {
      LockService.saveLock(reference, response.token);
      yield put(breakingLockSuccedded(reference, response));
    }
  } catch (error) {
    yield put(breakingLockFailed(reference, error));
  }
}

export const invalidateLockState = createAction(INVALIDATE_LOCK_STATE, (reference) => {
  return {
    reference,
  };
});

export default function* lockSaga() {
  yield takeEvery(ACQUIRE_LOCK_FOR_ENTITY_REQUEST, acquireLockSaga);
  yield takeEvery(RELEASE_LOCK_FOR_ENTITY_REQUEST, releaseLockSaga);
  yield takeEvery(BREAK_LOCK_FOR_ENTITY_REQUEST, breakLockSaga);
}